import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/ScmTypes";
import { useState, useEffect } from "react";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { homeService, IDeliveryFildes, IDeliveryDetails, IDeliverySearch } from "../../homeService"
import { transPgToPagination, formatNum } from "@/utils/utils";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";
export interface IDescTotal {
    totalNum: number,
    totalAmount: number
}
export const useDeliveryModel = createModel(function () {
    const { shopAndOrg } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg])
    const { shopCode, shopId } = shopAndOrg
    //切换站点清除缓存
    useEffect(() => {
        setSelectedRowKeys([]);
    }, [shopCode])
    const initSearchParam: IDeliverySearch = {};
    const initDataSource: IDeliveryDetails[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM };
    const initDesc = {
        totalNum: 0,
        totalAmount: 0
    }
    //查询条件
    const [searchParam, setSearchParam] = useState<IDeliverySearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IDeliveryDetails[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IDeliveryFildes>({});
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [descTotal, setDescTotal] = useState<IDescTotal>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<IDescTotal>(initDesc);
    const [descRows, setDescRows] = useState<IDeliveryDetails[]>([]);


    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IDeliveryDetails)
    }, [selectedRowKeys, dataSource])

    const updateSearchParam = (updateParam: IDeliveryFildes) => {
        // console.log(updateParam)
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
        setSelectedRow({})
    }
    const loadData = async (page?: ISearchPage, searchValue: IDeliverySearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        const { retData } = await homeService.Delivery(searchParams);
        if (retData) {
            const { records, ...pg } = retData
            setPgCfg(transPgToPagination(pg));
            setDataSource(records);
        }
    }

    const [wsConfirmModal, setWsConfirmModal] = useState<boolean>(false)
    return {
        initPgCfg,
        searchParam,
        dataSource,
        selectedRowKeys,
        selectedRow,
        pgCfg,
        descTotal,
        setSearchParam,
        setDataSource,
        setSelectedRowKeys,
        setSelectedRow,
        setPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData,
        setDescTotal,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows,
        wsConfirmModal, setWsConfirmModal
    }
})